import type { TFunction } from "i18next";
import { ApiError } from "@/lib/api-client";
import { AskNexusSignInRequiredError } from "@/features/ask-nexus/api/ask-nexus.api";

const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;
const HTTP_CONFLICT = 409;
const HTTP_TOO_MANY_REQUESTS = 429;

/** What the person can do about a failed request. Server error text is never shown. */
export function askNexusErrorMessage(t: TFunction, error: unknown, tenantName: string): string {
  if (error instanceof AskNexusSignInRequiredError) {
    return t("askNexus.errors.signIn", "Sign in again to use Ask Nexus.");
  }
  if (error instanceof ApiError) {
    if (error.status === HTTP_FORBIDDEN) {
      return t("askNexus.errors.forbidden", "You don't have access to Ask Nexus in {{tenant}}.", { tenant: tenantName });
    }
    if (error.status === HTTP_NOT_FOUND) {
      return t("askNexus.errors.notFound", "This chat isn't available. Start a new chat.");
    }
    if (error.status === HTTP_CONFLICT) {
      return t("askNexus.errors.conflict", "This chat can't take a new question right now. Wait for the answer, or start a new chat.");
    }
    if (error.status === HTTP_TOO_MANY_REQUESTS) {
      return t("askNexus.errors.rateLimited", "Too many questions in a short time. Try again in a minute.");
    }
  }
  return t("askNexus.errors.unavailable", "Ask Nexus is unavailable right now. Try again in a few minutes.");
}
